import colors from './colors'

const theme = {
  fontFamily: 'Roboto',
  fontSize: '1rem',
  headerHeight: '68px',
  footerHeight: '55px',
  giftItemControlPanelHeightPixels: 34,
  largeFieldHeight: '38px',
  fieldHeight: '32px',
  scrollbar: `
    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    ::-webkit-scrollbar-track {
        border-radius: 5px;
        background-color: ${colors.gray};
    }
    ::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background-color: ${colors.darkGray};
    }
  `,
  itemScrollbar: `
    ::-webkit-scrollbar {
      width: 4px;
    }
    ::-webkit-scrollbar-track {
      background-color: ${colors.lightGray};
    }
    ::-webkit-scrollbar-thumb {
      background-color: ${colors.darkerGray};
    }
  `,
  // inset is not supported in old browsers, using this instead
  inset0: `
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  `,
}

export enum ZIndex {
  Content = 0,
  // drop downs, anything above content
  AboveContent = 10,
  // the header, menu, other ui elements that stay on top
  Header = 20,
  // above everything, including notifications
  Cover = 10000,
}

export default theme
